export default {
  lang: {
    confirm: {
      title: '당신은 그것을 삭제하고 싶습니까? 삭제 후 복원 할 수 없습니다.',
      okText: '삭제',
      cancelText: '취소',
    },
  },
};
